/** AR05 copy (one group per control; a ticket edits only its own file). */
export const ar05PtBr = {
  title: 'Alterações de contrato e estimativas',
  description:
    'Marcos, aditivos, consumo, cancelamentos, descontos e estimativas variáveis revisados.',
  prerequisite: 'Requer a revisão versionada de alterações e estimativas.',
  reasons: {
    MILESTONE_NOT_IN_BASIS: 'Marco concluído sem refletir na base de reconhecimento',
    USAGE_NOT_IN_BASIS: 'Consumo finalizado sem refletir na base de reconhecimento',
    AMENDMENT_NOT_IN_BASIS: 'Aditivo aprovado com cronograma ainda na versão anterior',
    CANCELLATION_NOT_IN_BASIS: 'Contrato encerrado com cronograma ainda em execução',
    CREDIT_NOT_IN_BASIS: 'Cancelamento de NFS-e confirmado sem tratamento na base',
    DISCOUNT_NOT_IN_BASIS: 'Desconto aprovado aguardando decisão do aditivo',
    REVIEW_MISSING: 'Cálculo anexado sem revisão aprovada',
    REVIEW_INVALIDATED: 'Revisão invalidada por alteração nos dados ou na regra',
  },
  review: {
    approved: 'Aprovada',
    missing: 'Sem revisão',
    invalidated: 'Revisão invalidada',
    rejected: 'Rejeitada',
  },
  calculation: {
    kindCalculation: 'Cálculo',
    kindExternalSchedule: 'Cronograma externo',
    policyVersionLabel: 'Versão da política',
    documentRefLabel: 'Referência do documento',
  },
  observations: {
    VARIABLE_TERMS_UNSUPPORTED: 'Estimativas de contraprestação variável sem suporte de dados',
    CREDIT_NOTE_UNTRACEABLE: 'Notas de crédito do cliente sem vínculo rastreável a um contrato',
  },
  openContract: 'Abrir contrato',
  unsupportedCoverageNote:
    'Cobertura parcial: estimativas variáveis e notas de crédito não vinculáveis não são avaliadas por este controle.',
  listTruncated: 'Mostrando as primeiras {{shown}} de {{total}} pendências.',
};

export const ar05En: typeof ar05PtBr = {
  title: 'Contract changes and estimates',
  description:
    'Milestones, amendments, usage, cancellations, discounts and variable estimates reviewed.',
  prerequisite: 'Needs a versioned review of changes and estimates.',
  reasons: {
    MILESTONE_NOT_IN_BASIS: 'Completed milestone not reflected in the recognition basis',
    USAGE_NOT_IN_BASIS: 'Finalized usage not reflected in the recognition basis',
    AMENDMENT_NOT_IN_BASIS: 'Approved amendment with the schedule still on the earlier version',
    CANCELLATION_NOT_IN_BASIS: 'Terminated contract with a schedule still running',
    CREDIT_NOT_IN_BASIS: 'Confirmed NFS-e cancellation not treated in the basis',
    DISCOUNT_NOT_IN_BASIS: 'Approved discount awaiting the amendment decision',
    REVIEW_MISSING: 'Attached calculation with no approved review',
    REVIEW_INVALIDATED: 'Review invalidated by a data or rule change',
  },
  review: {
    approved: 'Approved',
    missing: 'No review',
    invalidated: 'Review invalidated',
    rejected: 'Rejected',
  },
  calculation: {
    kindCalculation: 'Calculation',
    kindExternalSchedule: 'External schedule',
    policyVersionLabel: 'Policy version',
    documentRefLabel: 'Document reference',
  },
  observations: {
    VARIABLE_TERMS_UNSUPPORTED: 'Variable-consideration estimates with no data support',
    CREDIT_NOTE_UNTRACEABLE: 'Customer credit notes with no traceable link to a contract',
  },
  openContract: 'Open contract',
  unsupportedCoverageNote:
    'Partial coverage: variable estimates and untraceable credit notes are not evaluated by this control.',
  listTruncated: 'Showing the first {{shown}} of {{total}} open items.',
};
